import script from "./ContentForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentForm.vue?vue&type=script&setup=true&lang=js"

import "./ContentForm.vue?vue&type=style&index=0&id=78d5c840&lang=css"

const __exports__ = script;

export default __exports__